export class UnidadModel {
    idUnidad?: number;
    idTipoUnidad?: number;
    codUnidad?: string;
    nomUnidad: string;
    desUnidad: string;
    desTipoUnidad : string;
    nomResponsable: string;
    isActivo: boolean;
    codCentroCostoGastoGeneral: string;
    
    constructor(){
        this.idUnidad = 0;
        this.idTipoUnidad = 0;
        this.codUnidad = '';
        this.nomUnidad = '';
        this.desUnidad = '';
        this.nomResponsable = '';
        this.isActivo = true;
        this.codCentroCostoGastoGeneral ='';
    }
}
